var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJira(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M22.249 11.384l-9.343-9.466L12 1 4.967 8.126l-3.216 3.258a.88.88 0 000 1.232l6.426 6.51L12 23l7.033-7.126.109-.11 3.107-3.148a.88.88 0 000-1.232zM12 15.252L8.79 12 12 8.748 15.21 12 12 15.252z"
  }))));
}

export default SvgJira;